import type { kitchenState, locationLabel, operationalState, vendorType } from '@/shared/types'

export interface VendorOnboardingData {
  vendorBasics: {
    aadhaarNumber: string
    panNumber: string
    contactNumber: string
    outletName: string
    vendorType: vendorType | ''
  }
  foodBusiness: {
    fssaiNumber: string
    kitchenState: kitchenState
    is247: boolean
    openingTime: string | undefined
    closingTime: string | undefined
  }
  clothingBusiness: {
    operationalState: operationalState
    returnPolicy: string
  }
  location: {
    address: string
    latitude: number
    longitude: number
    label: locationLabel
  }
  closedDays: {
    closedDays: string[]
  }
  categories: {
    categories: string[]
  }
  email: string
}

export const initialOnboardingData: VendorOnboardingData = {
  vendorBasics: {
    aadhaarNumber: '',
    panNumber: '',
    contactNumber: '',
    outletName: '',
    vendorType: '',
  },
  foodBusiness: {
    fssaiNumber: '',
    kitchenState: 'OPEN',
    is247: false,
    openingTime: undefined,
    closingTime: undefined,
  },
  clothingBusiness: {
    operationalState: 'OPEN',
    returnPolicy: '',
  },
  location: {
    address: '',
    latitude: 0,
    longitude: 0,
    label: 'OUTLET',
  },
  closedDays: {
    closedDays: [],
  },
  categories: {
    categories: [],
  },
  email: '',
}
